[
  {
    "title": "Aanrijding",
    "imageUrl": "/assets/images/eventtype/Aanrijding/Aanrijding.png",
    "highImpact": true,
    "children": [
      {
        "title": "Aanrijding",
        "imageUrl": "/assets/images/eventtype/Aanrijding/Aanrijding.png"
      },
      {
        "title": "Auto van de weg",
        "imageUrl": "/assets/images/eventtype/Aanrijding/Aanrijding-Auto-van-de-weg.png"
      },
      {
        "title": "Auto te water",
        "imageUrl": "/assets/images/eventtype/Aanrijding/Aanrijding-Auto-te-water.png"
      },
      {
        "title": "Dier",
        "imageUrl": "/assets/images/eventtype/Aanrijding/Aanrijding-Dier.png"
      },
      {
        "title": "Fietser",
        "imageUrl": "/assets/images/eventtype/Aanrijding/Aanrijding-Fietser.png"
      },
      {
        "title": "Kettingbotsing",
        "imageUrl": "/assets/images/eventtype/Aanrijding/Aanrijding-Kettingbotsing.png"
      },
      {
        "title": "Motor",
        "imageUrl": "/assets/images/eventtype/Aanrijding/Aanrijding-Motor.png"
      },
      {
        "title": "Openbaar vervoer",
        "imageUrl": "/assets/images/eventtype/Aanrijding/Aanrijding-OV.png"
      },
      {
        "title": "Voetganger",
        "imageUrl": "/assets/images/eventtype/Aanrijding/Aanrijding-Voetganger.png"
      }
    ]
  },
  {
    "title": "Brand",
    "imageUrl": "/assets/images/eventtype/Brand/Brand.png",
    "highImpact": true,
    "children": [
      {
        "title": "Autobrand",
        "imageUrl": "/assets/images/eventtype/Brand/Brand-Autobrand.png"
      },
      {
        "title": "Afhijsen",
        "imageUrl": "/assets/images/eventtype/Brand/Brand-Afhijsen.png"
      },
      {
        "title": "Chemische brand",
        "imageUrl": "/assets/images/eventtype/Brand/Brand-Chemische-brand.png"
      },
      {
        "title": "Explosie",
        "imageUrl": "/assets/images/eventtype/Brand/Brand-Explosie.png"
      },
      {
        "title": "Inzet blusvliegtuig",
        "imageUrl": "/assets/images/eventtype/Brand/Brand-Blusvliegtuig.png"
      },
      {
        "title": "Natuurbrand",
        "imageUrl": "/assets/images/eventtype/Brand/Brand-Natuurbrand.png"
      },
      {
        "title": "Overige",
        "imageUrl": "/assets/images/eventtype/Brand/Brand.png"
      },
      {
        "title": "Woningbrand",
        "imageUrl": "/assets/images/eventtype/Brand/Brand-Woningbrand.png"
      }
    ]
  },
  {
    "title": "Demonstratie",
    "imageUrl": "/assets/images/eventtype/Demonstratie/Demonstratie.png",
    "highImpact": true,
    "children": [
      {
        "title": "Demonstratie",
        "imageUrl": "/assets/images/eventtype/Demonstratie/Demonstratie.png"
      },
      {
        "title": "Inzet ME",
        "imageUrl": "/assets/images/eventtype/Demonstratie/Demonstratie-Inzet-ME.png"
      },
      {
        "title": "Rellen",
        "imageUrl": "/assets/images/eventtype/Demonstratie/Demonstratie-Rellen.png"
      }
    ]
  },
  {
    "title": "Diefstal",
    "imageUrl": "/assets/images/eventtype/Diefstal/Diefstal.png",
    "highImpact": true,
    "children": [
      {
        "title": "Autodiefstal",
        "imageUrl": "/assets/images/eventtype/Diefstal/Diefstal-Autodiefstal.png"
      },
      {
        "title": "Diefstal fiets",
        "imageUrl": "/assets/images/eventtype/Diefstal/Diefstal-Fiets.png"
      },
      {
        "title": "Overige",
        "imageUrl": "/assets/images/eventtype/Diefstal/Diefstal.png"
      },
      {
        "title": "Winkeldiefstal",
        "imageUrl": "/assets/images/eventtype/Diefstal/Diefstal-Winkeldiefstal.png"
      },
      {
        "title": "Zakkenroller",
        "imageUrl": "/assets/images/eventtype/Diefstal/Diefstal-Zakkenroller.png"
      }
    ]
  },
  {
    "title": "Evenement",
    "imageUrl": "/assets/images/eventtype/Evenement/Evenement.png",
    "highImpact": false,
    "children": [
      {
        "title": "Beurzen",
        "imageUrl": "/assets/images/eventtype/Evenement/Evenement_Beurzen.png"
      },
      {
        "title": "Bevrijdingsdag",
        "imageUrl": "/assets/images/eventtype/Evenement/Evenement_Bevrijdingsdag.png"
      },
      {
        "title": "Bloemencorso",
        "imageUrl": "/assets/images/eventtype/Evenement/Evenement_Bloemencorso.png"
      },
      {
        "title": "Carnaval",
        "imageUrl": "/assets/images/eventtype/Evenement/Evenement_Carnaval.png"
      },
      {
        "title": "Concert",
        "imageUrl": "/assets/images/eventtype/Evenement/Evenement_Concert.png"
      },
      {
        "title": "Culinair",
        "imageUrl": "/assets/images/eventtype/Evenement/Evenement_Culinair.png"
      },
      {
        "title": "Dans",
        "imageUrl": "/assets/images/eventtype/Evenement/Evenement_Dans.png"
      },
      {
        "title": "Herdenking",
        "imageUrl": "/assets/images/eventtype/Evenement/Evenement_Dodenherdenking.png"
      },
      {
        "title": "Festival",
        "imageUrl": "/assets/images/eventtype/Evenement/Evenement_Festival.png"
      },
      {
        "title": "Kermis",
        "imageUrl": "/assets/images/eventtype/Evenement/Evenement_Kermis.png"
      },
      {
        "title": "Oud en nieuw",
        "imageUrl": "/assets/images/eventtype/Evenement/Evenement_OudEnNieuw.png"
      },
      {
        "title": "Overige",
        "imageUrl": "/assets/images/eventtype/Evenement/Evenement_Overige.png"
      },
      {
        "title": "Parade",
        "imageUrl": "/assets/images/eventtype/Evenement/Evenement_Parade.png"
      },
      {
        "title": "Pride",
        "imageUrl": "/assets/images/eventtype/Evenement/Evenement_Pride.png"
      },
      {
        "title": "Vierdaagse",
        "imageUrl": "/assets/images/eventtype/Evenement/Evenement_Vierdaagse.png"
      },
      {
        "title": "Water",
        "imageUrl": "/assets/images/eventtype/Evenement/Evenement_Water.png"
      }
    ]
  },
  {
    "title": "Geweld",
    "imageUrl": "/assets/images/eventtype/Geweld/Geweld-Ruzie.png",
    "highImpact": true,
    "children": [
      {
        "title": "Asociaal verkeersgedrag",
        "imageUrl": "/assets/images/eventtype/Geweld/Geweld-Asociaal-verkeersgedrag.png"
      },
      {
        "title": "Carjacking",
        "imageUrl": "/assets/images/eventtype/Geweld/Geweld-Carjacking.png"
      },
      {
        "title": "Dierenmishandeling",
        "imageUrl": "/assets/images/eventtype/Geweld/Geweld-Dierenmishandeling.png"
      },
      {
        "title": "Explosief",
        "imageUrl": "/assets/images/eventtype/Geweld/Geweld-Explosief.png"
      },
      {
        "title": "Graffiti",
        "imageUrl": "/assets/images/eventtype/Geweld/Geweld-Graffiti.png"
      },
      {
        "title": "Overval",
        "imageUrl": "/assets/images/eventtype/Geweld/Geweld-Overval.png"
      },
      {
        "title": "Plofkraak",
        "imageUrl": "/assets/images/eventtype/Geweld/Geweld-Plofkraak.png"
      },
      {
        "title": "Ramkraak",
        "imageUrl": "/assets/images/eventtype/Geweld/Geweld-Ramkraak.png"
      },
      {
        "title": "Ruzie",
        "imageUrl": "/assets/images/eventtype/Geweld/Geweld-Ruzie.png"
      },
      {
        "title": "Schietpartij",
        "imageUrl": "/assets/images/eventtype/Geweld/Geweld-Schietpartij.png"
      },
      {
        "title": "Vechtpartij",
        "imageUrl": "/assets/images/eventtype/Geweld/Geweld-Vechtpartij.png"
      },
      {
        "title": "Vernieling",
        "imageUrl": "/assets/images/eventtype/Geweld/Geweld-Vernieling.png"
      }
    ]
  },
  {
    "title": "Hulpdiensten",
    "imageUrl": "/assets/images/eventtype/Hulpdiensten/Hulpdiensten-BOA.png",
    "highImpact": true,
    "children": [
      {
        "title": "Ambulance",
        "imageUrl": "/assets/images/eventtype/Hulpdiensten/Hulpdiensten-Ambulance.png"
      },
      {
        "title": "Arrestatieteam",
        "imageUrl": "/assets/images/eventtype/Hulpdiensten/Hulpdiensten-Arrestatieteam.png"
      },
      {
        "title": "BOA's",
        "imageUrl": "/assets/images/eventtype/Hulpdiensten/Hulpdiensten-BOA.png"
      },
      {
        "title": "Boswachter",
        "imageUrl": "/assets/images/eventtype/Hulpdiensten/Hulpdiensten-Boswachter.png"
      },
      {
        "title": "Brandweer",
        "imageUrl": "/assets/images/eventtype/Hulpdiensten/Hulpdiensten-Brandweer.png"
      },
      {
        "title": "Defensie",
        "imageUrl": "/assets/images/eventtype/Hulpdiensten/Hulpdiensten-Defensie.png"
      },
      {
        "title": "Dierenambulance",
        "imageUrl": "/assets/images/eventtype/Hulpdiensten/Hulpdiensten-Dierenambulance.png"
      },
      {
        "title": "Douane",
        "imageUrl": "/assets/images/eventtype/Hulpdiensten/Hulpdiensten-Douane.png"
      },
      {
        "title": "Explosieven Opruimingsdienst",
        "imageUrl": "/assets/images/eventtype/Hulpdiensten/Hulpdiensten-EOD.png"
      },
      {
        "title": "Kmar",
        "imageUrl": "/assets/images/eventtype/Hulpdiensten/Hulpdiensten-Kmar.png"
      },
      {
        "title": "Oefening",
        "imageUrl": "/assets/images/eventtype/Hulpdiensten/Hulpdiensten-Oefening.png"
      },
      {
        "title": "Open dag",
        "imageUrl": "/assets/images/eventtype/Hulpdiensten/Hulpdiensten-Open-dag.png"
      },
      {
        "title": "Politie",
        "imageUrl": "/assets/images/eventtype/Hulpdiensten/Hulpdiensten-Politie.png"
      },
      {
        "title": "Reddingsmaatschappij",
        "imageUrl": "/assets/images/eventtype/Hulpdiensten/Hulpdiensten-Reddingsmaatschappij.png"
      },
      {
        "title": "Rode Kruis",
        "imageUrl": "/assets/images/eventtype/Hulpdiensten/Hulpdiensten-Rode-kruis.png"
      }
    ]
  },
  {
    "title": "Inbraak",
    "imageUrl": "/assets/images/eventtype/Inbraak/Inbraak-Overige.png",
    "highImpact": true,
    "children": [
      {
        "title": "Auto",
        "imageUrl": "/assets/images/eventtype/Inbraak/Inbraak-Auto.png"
      },
      {
        "title": "Bedrijf",
        "imageUrl": "/assets/images/eventtype/Inbraak/Inbraak-Bedrijf.png"
      },
      {
        "title": "Overige",
        "imageUrl": "/assets/images/eventtype/Inbraak/Inbraak-Overige.png"
      },
      {
        "title": "Woning",
        "imageUrl": "/assets/images/eventtype/Inbraak/Inbraak-Woning.png"
      }
    ]
  },
  {
    "title": "Luchtvaart",
    "imageUrl": "/assets/images/eventtype/Luchtvaart/Luchtvaart.png",
    "highImpact": false,
    "children": [
      {
        "title": "Drone",
        "imageUrl": "/assets/images/eventtype/Luchtvaart/Luchtvaart-Drone.png"
      },
      {
        "title": "Gespot",
        "imageUrl": "/assets/images/eventtype/Luchtvaart/Luchtvaart-gespot.png"
      },
      {
        "title": "Luchtshow",
        "imageUrl": "/assets/images/eventtype/Luchtvaart/Luchtvaart-Luchtshow.png"
      },
      {
        "title": "Luchtballon",
        "imageUrl": "/assets/images/eventtype/Luchtvaart/Luchtvaart-Luchtballon.png"
      },
      {
        "title": "Luchtmacht",
        "imageUrl": "/assets/images/eventtype/Luchtvaart/Luchtvaart-Luchtmacht.png"
      },
      {
        "title": "Politiehelikopter",
        "imageUrl": "/assets/images/eventtype/Luchtvaart/Luchtvaart-Politiehelikopter.png"
      },
      {
        "title": "Traumahelikopter",
        "imageUrl": "/assets/images/eventtype/Luchtvaart/Luchtvaart-Traumahelikopter.png"
      }
    ]
  },
  {
    "title": "Milieu",
    "imageUrl": "/assets/images/eventtype/Milieu/Milieu-Overige.png",
    "highImpact": false,
    "children": [
      {
        "title": "Afval dumping",
        "imageUrl": "/assets/images/eventtype/Milieu/Milieu-Afval-dumping.png"
      },
      {
        "title": "Chemische dumping",
        "imageUrl": "/assets/images/eventtype/Milieu/Milieu-Chemische-afvaldumping.png"
      },
      {
        "title": "Olie",
        "imageUrl": "/assets/images/eventtype/Milieu/Milieu-Olie.png"
      },
      {
        "title": "Overige",
        "imageUrl": "/assets/images/eventtype/Milieu/Milieu-Overige.png"
      },
      {
        "title": "Waterschap",
        "imageUrl": "/assets/images/eventtype/Milieu/Milieu-Waterschap.png"
      }
    ]
  },
  {
    "title": "Natuurfenomeen",
    "imageUrl": "/assets/images/eventtype/Natuurfenomeen/Natuurfenomeen-Overige.png",
    "highImpact": false,
    "children": [
      {
        "title": "Aardbeving",
        "imageUrl": "/assets/images/eventtype/Natuurfenomeen/Natuurfenomeen-Aardbeving.png"
      },
      {
        "title": "Hagel",
        "imageUrl": "/assets/images/eventtype/Natuurfenomeen/Natuurfenomeen-Hagel.png"
      },
      {
        "title": "Modderstroom",
        "imageUrl": "/assets/images/eventtype/Natuurfenomeen/Natuurfenomeen-Modderstroom.png"
      },
      {
        "title": "Komeet",
        "imageUrl": "/assets/images/eventtype/Natuurfenomeen/Natuurfenomeen-Komeet.png"
      },
      {
        "title": "Onweer",
        "imageUrl": "/assets/images/eventtype/Natuurfenomeen/Natuurfenomeen-Onweer.png"
      },
      {
        "title": "Orkaan",
        "imageUrl": "/assets/images/eventtype/Natuurfenomeen/Natuurfenomeen-Orkaan.png"
      },
      {
        "title": "Overige",
        "imageUrl": "/assets/images/eventtype/Natuurfenomeen/Natuurfenomeen-Overige.png"
      },
      {
        "title": "Overstroming",
        "imageUrl": "/assets/images/eventtype/Natuurfenomeen/Natuurfenomeen-Overstroming.png"
      },
      {
        "title": "Sinkhole",
        "imageUrl": "/assets/images/eventtype/Natuurfenomeen/Natuurfenomeen-Sinkhole.png"
      },
      {
        "title": "Sneeuw",
        "imageUrl": "/assets/images/eventtype/Natuurfenomeen/Natuurfenomeen-Sneeuw.png"
      },
      {
        "title": "Storm",
        "imageUrl": "/assets/images/eventtype/Natuurfenomeen/Natuurfenomeen-Storm.png"
      },
      {
        "title": "Tornado",
        "imageUrl": "/assets/images/eventtype/Natuurfenomeen/Natuurfenomeen-Tornado.png"
      },
      {
        "title": "Vulkaanuitbarsting",
        "imageUrl": "/assets/images/eventtype/Natuurfenomeen/Natuurfenomeen-Vulkaanuitbarsting.png"
      },
      {
        "title": "Wateroverlast",
        "imageUrl": "/assets/images/eventtype/Natuurfenomeen/Natuurfenomeen-Wateroverlast.png"
      }
    ]
  },
  {
    "title": "Sport",
    "imageUrl": "/assets/images/eventtype/Sport/Sport-F1.png",
    "highImpact": false,
    "children": [
      {
        "title": "Basketbal",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-Basketbal.png"
      },
      {
        "title": "Bergklimmen",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-Bergklimmen.png"
      },
      {
        "title": "F1",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-F1.png"
      },
      {
        "title": "Golf",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-Golf.png"
      },
      {
        "title": "Marathon",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-Marathon.png"
      },
      {
        "title": "Motorcross",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-Motorcross.png"
      },
      {
        "title": "Obstacle run",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-Obstacle-run.png"
      },
      {
        "title": "Overige",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-Overige.png"
      },
      {
        "title": "Schaatsen",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-Schaatsen.png"
      },
      {
        "title": "Skatebaan",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-Skatebaan.png"
      },
      {
        "title": "Sportvissen",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-Sportvissen.png"
      },
      {
        "title": "Surfen",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-Surfen.png"
      },
      {
        "title": "Vechtsport",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-Vechtsport.png"
      },
      {
        "title": "Voetbal",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-Voetbal.png"
      },
      {
        "title": "Triatlon",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-Triatlon.png"
      },
      {
        "title": "Wielrennen",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-Wielrennen.png"
      },
      {
        "title": "Zeilen",
        "imageUrl": "/assets/images/eventtype/Sport/Sport-Zeilen.png"
      }
    ]
  },
  {
    "title": "Wildlife",
    "imageUrl": "/assets/images/eventtype/Wildlife/Wildlife-Overige.png",
    "highImpact": false,
    "children": [
      {
        "title": "Gespot",
        "imageUrl": "/assets/images/eventtype/Wildlife/Wildlife-Gespot.png"
      },
      {
        "title": "Gestrande dieren",
        "imageUrl": "/assets/images/eventtype/Wildlife/Wildlife-Gestrande-dieren.png"
      },
      {
        "title": "Overige",
        "imageUrl": "/assets/images/eventtype/Wildlife/Wildlife-Overige.png"
      },
      {
        "title": "Vissen",
        "imageUrl": "/assets/images/eventtype/Wildlife/Wildlife-Vissen.png"
      },
      {
        "title": "Vogels",
        "imageUrl": "/assets/images/eventtype/Wildlife/Wildlife-Vogels.png"
      }
    ]
  }
]